/**
 * decodeURIComponent를 적용하되, 잘못된 인코딩이면 원본을 그대로 반환합니다.
 */
export const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/**
 * 양쪽을 디코딩한 뒤 startsWith로 비교합니다.
 * 브라우저 pathname은 퍼센트 인코딩된 반면 사용자가 입력한 조건은 디코딩된 상태라 양쪽을 맞춰야 합니다.
 */
export const decodedStartsWith = (
  pathname: string,
  conditionPathname: string
): boolean => {
  return safeDecodeURIComponent(pathname).startsWith(
    safeDecodeURIComponent(conditionPathname)
  );
};
